import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomButton from "../customButton/CustomButton";
import {
  useToast,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
} from "@chakra-ui/react";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaCreditCard } from "react-icons/fa";
import CouponCard from "./CouponCard";

let BASE_URL_FLORAHUB;
let BASE_URL_BAG;

if (process.env.NODE_ENV === "production") {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_BAG = process.env.REACT_APP_API_URL_BAG;
} else {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_BAG = process.env.REACT_APP_API_URL_BAG;
}

const PaymentMethod = ({ orderId, reload, setReload, setFinalPriceData, paymentType,setPaymentType }) => {
  const accessToken = localStorage.getItem("token");
  // const [finalPriceData, setFinalPriceData] = useState(0);
  const [couponData, setCouponData] = useState([]);
  const [walletData, setWalletData] = useState("");
  const [isWalletChecked, setIsWalletChecked] = useState(false);
  const [couponModal, setCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);

  const toast = useToast();

  const handleSelectCoupon = () => {
    setCouponCode(couponCode);
  };
  // console.log("orderID line: 39", orderId);

  async function calculateAmount(coupon = "string", isWalletUsed = false) {
    setCouponLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL_FLORAHUB}/order/api/v1/order/calculate/order/amount`,
        {
          isWalletUsed,
          offerCode: coupon,
          orderType: "CART",
          orderId,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        setFinalPriceData(response.data.payload);
        if(coupon !== "string" && coupon !== "")
          setIsCouponApplied(true);
        else
          setIsCouponApplied(false);
        if (isWalletUsed === true || (coupon !== "string" && coupon !== "")) {
          toast({
            title: "Applied Successfully!",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        }
        setCouponModal(false);
        setCouponLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast({
          title: "Something went wrong!",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        setCouponModal(false);
      } else {
        toast({
          title: "Something went wrong!",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        setCouponModal(false);
      }
      setCouponLoading(false);
    }
  }

  async function getAllCoupons() {
    try {
      const response = await axios.get(
        `${BASE_URL_FLORAHUB}/offer/public-api/v1/all/coupons`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        setCouponData(response.data.payload);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("400 Error");
      } else {
        console.log("something went wrong ", error);
      }
    }
  }

  async function getWalletAmount() {
    try {
      const response = await axios.get(
        `${BASE_URL_BAG}/wishfybag/wallet/checkBalance`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        setWalletData(response.data.balance);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("400 Error");
      } else {
        console.log("something went wrong ", error);
      }
    }
  }

  useEffect(() => {
    getAllCoupons();
    getWalletAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (couponCode.length >= 5 && isTyping === false) {
      calculateAmount(couponCode, isWalletChecked);
    }
    setReload(!reload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponCode, isTyping]);

  useEffect(() => {
    calculateAmount(couponCode, isWalletChecked);
    setReload(!reload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWalletChecked]);

  // console.log(couponData);
  // console.log("couponLoading ",couponLoading)

  return (
    <>
      {/* <p className='text-xl text-left my-2 pl-2 font-medium py-2'>2. Choose payment method</p> */}
      <div className="w-full bg-white border border-gray-200 rounded-lg shadow p-3 md:p-5">
        <div className="text-left">
          <p className="uppercase font-semibold">Your available balance</p>
          <div className={`${walletData === 0 ? "text-gray-400" : ""}`}>
            <input
              className={`mr-3 ${walletData === 0 ? "cursor-none" : ""}`}
              type="checkbox"
              checked={isWalletChecked}
              disabled={walletData === 0}
              onChange={(e) => {
                setIsWalletChecked(e.target.checked);
                setReload(!reload);
              }}
            />
            Use your {walletData} Wishfy Wallet Balance
          </div>
        </div>

        <p className="text-left uppercase font-semibold mt-3">Coupons</p>
        <div className="flex justify-between">
          <p>{couponCode.length === 0 ? "Apply Coupons" : couponCode}</p>
          <CustomButton
            size="small"
            onClick={() => {
              //Open Coupon Modal
              setCouponModal(true);
            }}
          >
            {isCouponApplied ? "Change Coupon" : "Select Coupon"}
          </CustomButton>
        </div>

        <hr className="my-5" />

        <div className="flex items-center justify-between border border-gray-400 max-w-[320px] rounded p-5">
          <div className="flex flex-col items-center justify-center gap-2">
            <FaIndianRupeeSign className="w-5 h-5" />
            <p>Cash on Delivery</p>
            <input
              type="radio"
              checked={paymentType==='CART'}
              onClick={()=>{
                setPaymentType("CART")
              }}
            />
          </div>

          <div className="flex flex-col items-center justify-center gap-2">
            <FaCreditCard className="w-5 h-5" />
            <p>Pay Online</p>
            <input 
              type="radio" 
              checked={paymentType ==="PAY_ONLINE"}
              disabled={true}
              onClick={()=>{
                setPaymentType("PAY_ONLINE")
              }}
            />
          </div>
        </div>

        <Modal
          blockScrollOnMount={true}
          isOpen={couponModal}
          onClose={() => {
            setCouponModal(false);
          }}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              {couponData?.length > 0 ? (
                <div>
                  <p>Congrats! {couponData?.length} Offers Today </p>
                  <div className="flex justify-between items-center ">
                    <div>
                      <input
                        value={couponCode}
                        onChange={(e) => {
                          setIsTyping(true);
                          setCouponCode(e.target.value);
                        }}
                        type="text"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm p-1 "
                      />
                    </div>
                    <div>
                      <CustomButton
                        size="small"
                        onClick={() => {
                          setIsTyping(false);
                          handleSelectCoupon();
                        }}
                      >
                        Apply
                      </CustomButton>
                    </div>
                  </div>

                  <hr className="my-3" />

                  <div className="mt-2">
                    <div className="flex justify-between my-3 text-sm">
                      <p>Available Coupons</p>
                    </div>
                    <div>
                      {couponLoading && (
                        <div className="flex items-center gap-3 ">
                          Applying Coupon <Spinner />
                        </div>
                      )}
                    </div>
                    {couponData?.map((coupon, index) => {
                      return (
                        <CouponCard
                          coupon={coupon}
                          key={index}
                          setIsTyping={setIsTyping}
                          setCouponCode={setCouponCode}
                          couponCode={couponCode}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div>No Coupon For You.</div>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </>
  );
};

export default PaymentMethod;

